import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "relative inline-flex flex-col w-60 text-sm font-medium text-gray-700 group hover:text-gray-900" }
const _hoisted_2 = { class: "block truncate" }
const _hoisted_3 = { class: "absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none" }
const _hoisted_4 = {
  key: 0,
  class: "absolute inset-y-0 left-0 flex items-center pl-3 text-clay-800"
}

import {
  Listbox,
  ListboxButton,
  ListboxOption,
  ListboxOptions
} from "@headlessui/vue";
import { CheckIcon, ChevronUpDownIcon } from "@heroicons/vue/20/solid";

// Props

export default /*@__PURE__*/_defineComponent({
  __name: 'SaSelect',
  props: /*@__PURE__*/_mergeModels({
    options: {}
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {



const modelValue = _useModel<any>(__props, "modelValue");

// Utility: primitive check
function isPrimitive(value: any): value is string | number {
  return typeof value === "string" || typeof value === "number";
}

// Utility: fallback key
function getOptionKey(option: any): string | number {
  return isPrimitive(option) ? option : JSON.stringify(option);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Listbox), {
    modelValue: modelValue.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(ListboxButton), { class: "relative w-full py-2 pl-3 pr-10 text-left bg-white border rounded-lg shadow-md cursor-default focus:outline-hidden focus-visible:border-clay-600 focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 focus-visible:ring-offset-orange-300 sm:text-sm" }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "selected", { option: modelValue.value }, () => [
              _createElementVNode("span", _hoisted_2, _toDisplayString(isPrimitive(modelValue.value) ? modelValue.value : "Select an option"), 1)
            ]),
            _createElementVNode("span", _hoisted_3, [
              _createVNode(_unref(ChevronUpDownIcon), {
                "aria-hidden": "true",
                class: "w-5 h-5 text-gray-400"
              })
            ])
          ]),
          _: 3
        }),
        _createVNode(_Transition, {
          "leave-active-class": "transition duration-100 ease-in",
          "leave-from-class": "opacity-100",
          "leave-to-class": "opacity-0"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(ListboxOptions), { class: "absolute top-full left-0 z-10 mt-1 w-full overflow-auto text-base bg-white rounded-md shadow-lg max-h-60 ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
                  return (_openBlock(), _createBlock(_unref(ListboxOption), {
                    key: getOptionKey(option),
                    value: option,
                    disabled: option?.disabled,
                    as: "template"
                  }, {
                    default: _withCtx(({ active, selected, disabled }) => [
                      _createElementVNode("li", {
                        class: _normalizeClass([
                disabled
                  ? 'opacity-50 cursor-not-allowed'
                  : active
                  ? 'bg-clay-100 text-clay-900'
                  : 'text-gray-900',
                'relative cursor-default select-none py-2 pl-10 pr-4'
              ])
                      }, [
                        _createElementVNode("span", {
                          class: _normalizeClass([
                  selected ? 'font-bold' : 'font-normal',
                  'block truncate'
                ])
                        }, [
                          _renderSlot(_ctx.$slots, "option", {
                            option: option,
                            selected: selected,
                            disabled: disabled
                          }, () => [
                            _createTextVNode(_toDisplayString(isPrimitive(option) ? option : ""), 1)
                          ])
                        ], 2),
                        (selected && !disabled)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                              _createVNode(_unref(CheckIcon), {
                                "aria-hidden": "true",
                                class: "w-5 h-5"
                              })
                            ]))
                          : _createCommentVNode("", true)
                      ], 2)
                    ]),
                    _: 2
                  }, 1032, ["value", "disabled"]))
                }), 128))
              ]),
              _: 3
            })
          ]),
          _: 3
        })
      ])
    ]),
    _: 3
  }, 8, ["modelValue"]))
}
}

})